import { Account, EntitlementsContextApi, User } from '@sharefiledev/sharefile-appshell';
import { StateCreator } from 'zustand';

type State = {
	user: User;
	account: Account;
	entitlements: EntitlementsContextApi;
};

type Actions = {
	setSFUserContext: (sfUserContext: {
		user: User;
		account: Account;
		entitlements: EntitlementsContextApi;
	}) => void;
};

export type SFUserContextState = State & Actions;

const initialState = {
	user: null,
	account: null,
	entitlements: null,
};

export const createSFUserContextSlice: StateCreator<SFUserContextState> = set => {
	return {
		...initialState,
		setSFUserContext: sfUserContext => {
			set({
				user: sfUserContext.user,
				account: sfUserContext.account,
				entitlements: sfUserContext.entitlements,
			});
		},
	};
};
